import {
    TERMS_ALLGET
} from "../../constant/ActionType";

export default function TermViewAllReducer(state = {
    termsGetin: [],
    statusCode: null,
}, action) {
    switch (action.type) {
        case TERMS_ALLGET:
            return {
                ...state,
                termsGetin: action.data,
                    statusCode: action.status
            };

        default:
    }
    return state;
}